// src/pages/admin/DashboardPage.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, Spinner } from 'react-bootstrap';
import { FaUserTie, FaMoneyBillWave, FaGift, FaHourglassHalf, FaFirstOrder } from 'react-icons/fa';

const DashboardAdmin = () => {
  const [stats, setStats] = useState(null);
  const token = localStorage.getItem('token');

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/stats`, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(res => {
      setStats(res.data);
    });
  }, []);

  if (!stats) return <div className="text-center mt-5"><Spinner animation="border" /></div>;

  return (
    <div className="container py-4">
      <h3 className="mb-4">📊 Dashboard</h3>
      <div className="row g-4">
        <StatCard title="Total Officers" icon={<FaUserTie />} value={stats.totalOfficers} />
        <StatCard title="Pending Salaries" icon={<FaHourglassHalf />} value={stats.pendingSalaries} />
        <StatCard title="Requested Salaries" icon={<FaFirstOrder />} value={stats.requestedSalaries} />
        <StatCard title="Paid This Month" icon={<FaMoneyBillWave />} value={`Rp ${Number(stats.paidSalaries).toLocaleString()}`} />
        <StatCard title="This Month's Birthdays" icon={<FaGift />} value={stats.birthdays} />
      </div>
    </div>
  );
};

const StatCard = ({ title, icon, value }) => (
  <div className="col-md-3">
    <Card className="shadow-sm text-center h-100">
      <Card.Body>
        <div className="fs-2 mb-2 text-primary">{icon}</div>
        <Card.Title>{title}</Card.Title>
        <Card.Text className="fs-4 fw-bold">{value}</Card.Text>
      </Card.Body>
    </Card>
  </div>
);

export default DashboardAdmin;
